import Vue from 'vue'
import Router from 'vue-router'
import AuthCenter from '@/components/AuthCenter'
import Dashboard from '@/components/Dashboard'
import store from '@/store'

// 在文件顶部添加
let isRoutesInjected = false;

Vue.use(Router)

export const allDynamicRoutes = [
  {
    path: 'start-print-images',
    component: () => import('@/components/dashboard/components/StartPrintImages.vue'),
    meta: { title: '打印图片' }
  },
  {
    path: 'start-print',
    component: () => import('@/components/dashboard/components/StartPrint.vue'),
    meta: { title: '开始打印' }
  },
  {
    path: 'stat-info',
    component: () => import('@/components/dashboard/components/StatInfo.vue'),
    meta: { title: '打印统计' }
  },
  {
    path: 'template-manage',
    component: () => import('@/components/dashboard/components/TemplateManagement.vue'),
    meta: { title: '模板管理' }
  },
  {
    path: 'template-editor',
    component: () => import('@/components/dashboard/components/TemplateEditor.vue'),
    meta: { title: '模板编辑' }
  },
  {
    path: 'paper-manage',
    component: () => import('@/components/dashboard/components/PaperManagement.vue'),
    meta: { title: '纸张管理' }
  },
  {
    path: 'gateway-task-manage',
    component: () => import('@/components/dashboard/components/GatewayTaskManagement.vue'),
    meta: { title: '打印任务' }
  },
  {
    path: 'queue-manage',
    component: () => import('@/components/dashboard/components/QueueManage.vue'),
    meta: { title: '打印队列' }
  },
  {
    path: 'gateway-manage',
    component: () => import('@/components/dashboard/components/GatewayManagement.vue'),
    meta: { title: '网关管理' }
  },
  {
    path: 'attr-manage',
    component: () => import('@/components/dashboard/components/AttrManage.vue'),
    meta: { title: '属性管理' }
  },
  {
    path: 'my-studios',
    component: () => import('@/components/dashboard/components/MyStudios.vue'),
    meta: { title: '我的工作室' }
  },
  {
    path: 'studio-create',
    component: () => import('@/components/dashboard/components/StudioCreate.vue'),
    meta: { title: '创建工作室' }
  },
  {
    path: 'studio-detail',
    component: () => import('@/components/dashboard/components/StudioDetail.vue'),
    meta: { title: '工作室详情' }
  },
  {
    path: 'studio-users',
    component: () => import('@/components/dashboard/components/StudioUsers.vue'),
    meta: { title: '成员管理' }
  },
  {
    path: 'studio-invite',
    component: () => import('@/components/dashboard/components/StudioInvite.vue'),
    meta: { title: '邀请码管理' }
  },
  {
    path: 'studio-join',
    component: () => import('@/components/dashboard/components/StudioJoin.vue'),
    meta: { title: '加入工作室' }
  },
  {
    path: 'studio-admin-list',
    component: () => import('@/components/dashboard/components/StudioAdminList.vue'),
    meta: { title: '工作室管理（系统）' }
  },
  {
    path: 'system-users',
    component: () => import('@/components/dashboard/components/SystemUsers.vue'),
    meta: { title: '用户管理（系统）' }
  },
  {
    path: 'policies',
    component: () => import('@/components/dashboard/components/PolicyRules.vue'),
    meta: { title: '权限策略管理' }
  },
  {
    path: 'profile',
    component: () => import('@/components/dashboard/components/Profile.vue'),
    meta: { title: '个人信息' }
  },
  {
    path: 'change-password',
    component: () => import('@/components/dashboard/components/ChangePassword.vue'),
    meta: { title: '修改密码' }
  },
  {
    path: 'logout',
    component: () => import('@/components/dashboard/components/Logout.vue'),
    meta: { title: '退出登录' }
  },
  {
    path: 'studio-create-admin',
    component: () => import('@/components/dashboard/components/StudioCreateAdmin.vue'),
    meta: { title: '创建工作室（管理员）' }
  },
  {
    path: 'version',
    component: () => import('@/components/dashboard/components/Version.vue'),
    meta: { title: '版本信息' }
  }
]


const createRouter = () => new Router({
  mode: 'history',
  routes: [
    { path: '/', component: AuthCenter },
    {
      path: '/dashboard',
      component: Dashboard,
      meta: { requiresAuth: true },
      children: [] // 预定义children数组
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})


const router = createRouter()

// ✅ 增强版动态路由注入
export async function injectDynamicRoutes(dynamicChildren) {


  // 获取当前路由配置的副本
  const routes = [...router.options.routes]

  // 找到Main路由索引
  const mainIndex = routes.findIndex(r => r.path === '/dashboard')

  if (mainIndex !== -1) {
    // 克隆Main路由对象避免污染原始配置
    const mainRoute = { ...routes[mainIndex] }

    // 添加子路由（确保path不带前导斜杠）
    mainRoute.children = dynamicChildren.map(route => ({
      ...route,
      path: route.path.replace(/^\//, ''),
      meta: { ...route.meta, requiresAuth: true }
    }))

    // 更新路由配置
    routes[mainIndex] = mainRoute

    // 创建新router实例获取matcher
    const newRouter = new Router({
      mode: 'history',
      routes
    })

    // 重要：同时更新router实例和options
    router.matcher = newRouter.matcher
    router.options.routes = routes

    // 保存权限到Vuex
    store.commit('SET_PERMISSIONS', dynamicChildren.map(r => r.path))
    // console.log('路由注入完成', router.getRoutes())
  }
}

// ✅ 增强版初始化方法
export async function initDynamicRoutes() {

  if (isRoutesInjected) return;


  const token = localStorage.getItem('access_token')
  if (!token) return

  try {
    // 1. 获取后端返回的允许访问路径
    const res = await store.dispatch('fetchUserPermissions')
    const allowedPaths = res || []

    // 2. 过滤出有权限的路由
    const filtered = allDynamicRoutes.filter(route =>
      allowedPaths.includes(route.path)
    )

    // 3. 注入路由
    injectDynamicRoutes(filtered)

    isRoutesInjected = true

  } catch (error) {
    console.error('路由初始化失败:', error)
    // 降级方案：注入空路由或默认路由
    injectDynamicRoutes([])
    isRoutesInjected = true
  }
}

// 路由守卫
router.beforeEach(async (to, from, next) => {

  // 1. 不需要认证的路由直接放行
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    return next()
  }

  // 2. 检查是否已登录
  const isAuthenticated = !!localStorage.getItem('access_token')
  if (!isAuthenticated) {

    return next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  }

  if (!isRoutesInjected) {
    await initDynamicRoutes()
    return next({ ...to, replace: true })
  }

  // 3. 检查是否有权限
  const hasPermission = store.getters.hasPermission(to.path.replace('/dashboard/', ''))
  if (hasPermission) {
    // 确保路由已注入
    if (to.matched.length === 0) {
      await initDynamicRoutes()
      return next({ ...to, replace: true })
    } else {
      return next()
    }
  } else {
    next('/403') // 或跳转到无权限页面
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js